<link rel="stylesheet"
    href="https://demos.creative-tim.com/notus-js/assets/vendor/@fortawesome/fontawesome-free/css/all.min.css">

<div class="flex justify-center">
    <h2 class="font-light leading-relaxed text-2xl mt-6 text-gray-800 cursor-default"
        style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Formative Evaluation score for
        {{city}}</h2>
</div>
<div class="flex justify-center">
    <div class="w-1/3 h-1/3 mt-12">
        <canvas baseChart [datasets]="barChartData[0].barchartDataObject" [labels]="barChartLabels"
            [options]="barChartOptions" [colors]="chartColors" [chartType]="barChartType">
        </canvas>
    </div>
</div>
<div *ngIf="allowed">
    <div class="flex justify-center">
        <h2 class="text-center font-light leading-relaxed text-md mt-6 text-gray-800 cursor-default">
            To calculate the score, please click one of the four buttons below to start the corresponding questionnaire.
            Each questionnaire will take approximately 10 minutes to complete.<br>
            <p class="text-red-400 italic">*Once you begin a questionnaire, you will not be able to exit the page until
                the survey is finished.</p>
        </h2>
    </div>
    <section class="mt-16">
        <ul id="routes">
            <li>
                <div class="h-48 w-48 p-8 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400"
                    (click)="onBaseline()">
                    <div class="flex flex-col">
                        <i class="far fa-chart-bar text-4xl"></i>
                        <div class="text-2xl">
                            Baseline
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div class="h-48 w-48 p-8 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400"
                    (click)="onM24()">
                    <div class="flex flex-col">
                        <i class="far fa-chart-bar text-4xl"></i>
                        <div class="text-2xl">
                            M24
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div class="h-48 w-48 p-8 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400"
                    (click)="onM36()">
                    <div class="flex flex-col">
                        <i class="far fa-chart-bar text-4xl"></i>
                        <div class="text-2xl">
                            M36
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div class="h-48 w-48 p-8 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400"
                    (click)="onM42()">
                    <div class="flex flex-col">
                        <i class="far fa-chart-bar text-4xl"></i>
                        <div class="text-2xl">
                            M42
                        </div>
                    </div>
                </div>
            </li>
            <li>
                <div class="h-48 w-48 p-8 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400"
                    (click)="onInfo()">
                    <div class="flex flex-col">
                        <i class="fas fa-info text-4xl"></i>
                        <div class="text-2xl">
                            Info
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </section>
</div>